<template>
  <PopDialog
    title="조명제어기 이름"
    :visible="props.visible"
    :okCallback="onOkClick"
    :cancelCallback="onCancelClick"
  >
    <div class="mb-2 text-muted" style="font-size: 0.8rem;">
      <i class="fa-solid fa-hashtag me-1"></i>{{ props.serial }}
    </div>
    <input
      type="text"
      maxlength="40"
      class="form-control form-control-lg fs-15px"
      placeholder="제어기 이름을 입력해주세요."
      v-model="modifiedName"
    />
  </PopDialog>
</template>

<script setup>
import { ref, watch, defineProps } from 'vue';
import PopDialog from '@/common/components/popup/PopDialog.vue';

const props = defineProps({
  visible: { type: Boolean, default: false },
  okCallback: { type: Function, default: null },
  cancelCallback: { type: Function, default: null },
  serial: { type: String, default: '' },
  controllerName: { type: String, default: '' },
});

const modifiedName = ref(props.controllerName || '');

watch(
  () => [props.visible, props.controllerName],
  () => {
    if (props.visible) {
      modifiedName.value = props.controllerName || '';
    }
  },
);

const onOkClick = () => {
  if (props.okCallback) {
    props.okCallback(modifiedName.value);
  }
};

const onCancelClick = () => {
  if (props.cancelCallback) {
    props.cancelCallback();
  }
};
</script>
